import { emitter } from "@/services/emitter.service";

export async function appIsFocused() {
    return document.hasFocus();
}

let window_is_focused = true;
window.addEventListener("focus", () => {
    window_is_focused = true;
    emitBrowserFocusEvent();
});
window.addEventListener("blur", () => {
    window_is_focused = false;
    emitBrowserFocusEvent();
});

let tab_is_visible = true;
document.addEventListener("visibilitychange", () => {
    tab_is_visible = document.visibilityState === "visible";
    emitBrowserFocusEvent();
});

let ebfe_debouncer: NodeJS.Timeout | null = null;
function emitBrowserFocusEvent() {
    if (ebfe_debouncer !== null) clearTimeout(ebfe_debouncer);
    ebfe_debouncer = setTimeout(() => {
        emitter.emit("Browser::activestatechange", window_is_focused && tab_is_visible);
        ebfe_debouncer = null;
    }, 10);
}
